import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements OnInit {
    @Input() symbol: string;
    @Input() cssClass: string;
    @Input() height: string;
    @Input() width: string;
    svg: string;

    ngOnInit() {
        this.svg = `/assets/icons/${this.symbol}.svg`;
    }
}
